import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/estimate-pdf')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/estimates' });
  },
  component: () => null,
});
